{
  "pt": {
    "issue": {
      "actions": {
        "approve_for_customer": "Aprovar para o cliente",
        "cancel_approval": "Cancel customer approval",
        "collapse": "Problemas de colapso",
        "create_category": "Adicionar nova categoria",
        "create_issue": "Criar obstáculo",
        "create_issue_customer": "Comunicar defeito",
        "delete": "Eliminar o obstáculo",
        "expand": "Expandir os obstáculos",
        "export_images": "Descarregar imagens",
        "hideActivity": "Ocultar atividade",
        "hideDetails": "Ocultar detalhes",
        "openConversation": "Abrir conversa",
        "reject_for_customer": "Rejeitar para o cliente",
        "request_approval": "Request customer approval",
        "show": "Mostrar obstáculo",
        "showActivity": "Mostrar atividade",
        "showDetails": "Mostrar detalhes",
        "startConversation": "Iniciar conversa",
        "start_conversation": "Iniciar conversa sobre este obstáculo",
        "undo_customer_approval": "Anular a aprovação do cliente",
        "undo_customer_rejection": "Anular a rejeição do cliente",
        "update": "Atualizar problemas"
      },
      "attributes": {
        "approval_status": "Estado de aprovação",
        "assignee": "Responsável",
        "category": "Categoria",
        "created_at": "Criado",
        "deadline": "Prazo de entrega",
        "description": "Descrição",
        "issue_list_type": "Lista de reclamações",
        "name": "Nome",
        "responsible": "Responsável",
        "status": "Estado",
        "statuses": {
          "approval_not_requested": "Aprovação Não Solicitada",
          "approval_requested": "Aprovação Solicitada",
          "approved": "Aprovado",
          "completed": "Concluído",
          "created": "Aberto",
          "declined": "Recusado",
          "inbox": "Enviado",
          "not_completed": "Não concluído",
          "ongoing": "Em curso"
        },
        "updated_at": "Última atualização"
      },
      "edit_actions": {
        "edit_category": "Categoria",
        "edit_deadline": "Prazo de entrega",
        "edit_issue_list_type": "Lista de reclamações",
        "edit_responsible": "Responsável",
        "edit_status": "Estado"
      },
      "labels": {
        "activity": "Atividade",
        "addImagesSubtitle": "Uma imagem diz mais do que mil palavras",
        "addImagesTitle": "Adicionar imagens para nos ajudar a compreender ainda melhor o defeito",
        "after_care_page_title": "Os seus problemas",
        "all_categories_can_be_managed_under": "Todas as categorias podem ser geridas em",
        "approvalNotRequested": "Aprovação não solicitada",
        "approvalRequested": "Aprovação solicitada",
        "approved": "Aprovado",
        "approvedInfo": "O cliente aprovou este obstáculo",
        "assignee": "Responsável",
        "cancelCustomerApproval": "Cancelar a aprovação do cliente",
        "collapse": "Ocultar atividade",
        "company_settings": "definições da empresa",
        "count_edit": "Editar obstáculo | Editar {count} obstáculo",
        "create_new_category?": "Não encontra a categoria de que necessita? Crie uma nova!",
        "created_at": "Criado em",
        "customerApproved": "Aprovado pelo cliente",
        "customerRejected": "Rejeitado pelo cliente",
        "deadline_date": "Prazo de entrega",
        "description": "Descrição",
        "descriptionSubtitle": "Utilizar marcadores e frases curtas para facilitar a compreensão do defeito",
        "descriptionTitle": "Dar uma breve descrição",
        "edit_category": "Editar categoria",
        "edit_issue": "Editar problema",
        "isThisPointFixed": "Está fixo segundo você?",
        "issue_category_name": "Categoria",
        "issue_status_name": "Estado",
        "issues_selected": "obstáculos selecionados",
        "name": "Nome",
        "new": "Criar novo obstáculo",
        "new_category": "Nova categoria",
        "noDescriptionYet": "Ainda não há descrição",
        "no_issue_deadline": "Sem prazo definido",
        "no_issues": "Sem problemas",
        "no_responsible": "Não responsável",
        "origin": "Origem",
        "reason": "Motivo",
        "redoRequest": "Pedido de refazer",
        "requestCustomerApproval": "Solicitar a aprovação do cliente",
        "requested": "Solicitado",
        "requestedInfo": "Aprovação do cliente solicitada",
        "resetRequest": "Pedido de reposição",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Responsável",
        "return_to_overview": "Voltar",
        "showIssuesfor": "Mostrar obstáculos para",
        "statusExplained": "O que significa cada cor de estado",
        "subjectSubtitle": "Só é necessário 1 relatório por defeito. Nós tratamos do resto",
        "subjectTitle": "Descreva o defeito em poucas palavras",
        "undoCustomerApproved": "Anular a aprovação do cliente",
        "unit_issues_will_be_shown_here": "Todas as unidades que constam da lista de obstáculos serão mostradas aqui",
        "unit_name": "Nome da unidade",
        "updated_at": "Última atualização",
        "waitingForApproval": "Este ponto tem de ser aceite pelo cliente antes de se poder iniciar uma conversa",
        "whyIsThisPointNotFixed": "Porque é que este ponto não é fixo?",
        "youApprovedThisPoint": "Fixo segundo você",
        "youRejectedThisPoint": "Não fixo segundo você"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Será notificado se for comunicado um novo defeito.",
            "title": "Ainda não foram comunicados defeitos para a sua unidade"
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "Quando os clientes criarem novos problemas, estes serão novamente apresentados aqui.",
            "title": "Processou todos os problemas recebidos dos clientes"
          },
          "none": {
            "subtitle": "Começar a registar o que deve ser corrigido ou melhorado",
            "title": "Criar o seu primeiro obstáculo"
          },
          "overview": {
            "subtitle": "Crie o seu primeiro obstáculo dentro de uma unidade para começar",
            "title": "Os problemas criados em todas as suas unidades serão mostrados aqui"
          },
          "unit": {
            "title": "Todos os problemas para esta unidade serão mostrados aqui"
          }
        },
        "partners": {
          "none": {
            "subtitle": "A partir do momento em que lhe são atribuídos pontos, estes serão visíveis aqui",
            "title": "Ainda não lhe foram atribuídos pontos"
          }
        }
      },
      "sortGroups": {
        "date": "Data",
        "deadline": "Prazo de entrega",
        "name": "Nome"
      },
      "toasts": {
        "update": "Obstáculo atualizado"
      },
      "validation": {
        "issue_list_type_required": "É necessária uma lista de reparação",
        "pleaseProvideAReason": "Por favor, indique um motivo",
        "status_required": "O estatuto é necessário"
      }
    }
  }
}
